import { HttpService } from "../../services/http-service";
import { ApplicationSettings } from "../../services/settings-service";
import { autoinject } from "aurelia-framework";

@autoinject()
export class Downloads
{
    
    isInternalUser :boolean;

    constructor(private readonly http: HttpService,
        private readonly appSettings: ApplicationSettings)
    { }

    activate = () =>
    {
        this.isInternalUser = this.appSettings.settings.isInternalUser;
    }


    downloadOfficeDetails = () => 
    {
        this.http.downloadFile("/Office/GetOfficeListAsCsv");
    }

    downloadSchoolList = () => 
    {
        this.http.downloadFile("/School/GetSchoolListAsCsv");
    }

    downloadPublicSchoolList = () => 
    {
        this.http.downloadFile("/School/GetPublicSchoolListAsCsv");
    }

}